import { useEffect, useState } from "react";
import { getDistricts } from "../api/districtsService";
import { DEFAULT_DISTRICTS } from "../utils/districts";

// Lista sectoarelor se cere o singură dată pe sesiune; după o schimbare din
// Instrumente se reîncarcă (reloadDistricts).

let pending = null;
const listeners = new Set();

export function loadDistricts() {
   if (!pending) {
      pending = getDistricts()
         .then((list) => (Array.isArray(list) && list.length ? list : DEFAULT_DISTRICTS))
         .catch((err) => {
            pending = null;
            throw err;
         });
   }
   return pending;
}

export function reloadDistricts() {
   pending = null;
   return loadDistricts().then((list) => {
      listeners.forEach((fn) => fn(list));
      return list;
   });
}

/** Sectoarele (și cele dezactivate); până răspunde serverul — cele implicite. */
export default function useDistricts() {
   const [districts, setDistricts] = useState(DEFAULT_DISTRICTS);

   useEffect(() => {
      let alive = true;
      const update = (list) => {
         if (alive) setDistricts(list);
      };
      listeners.add(update);
      loadDistricts()
         .then(update)
         .catch(() => {});
      return () => {
         alive = false;
         listeners.delete(update);
      };
   }, []);

   return districts;
}
